// extracted by mini-css-extract-plugin
export default {"Checkbox":"Checkbox_Checkbox__qpann","invalid":"Checkbox_invalid__956X2","ColorCheckbox":"Checkbox_ColorCheckbox__YX+hi"};